import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Trail Adventures",
    date: "4 August, 2025",
    admin: "Admin",
    heading: "Unforgettable Hiking Trails Adventure Experience",
    important: {
      content: "Gain valuable insights from seasoned hikers and guides to maximize your outdoor adventures. From selecting ideal trails to handling rugged terrains, their tips ensure a safe and memorable hiking experience.",
      intro: "Adventure Expert"
    },
    paragraph: {
      para1: "Embark on a journey through some of the world’s most unforgettable hiking trails, perfect for nature lovers and thrill-seekers alike. These trails offer stunning vistas, diverse terrains, and enriching outdoor experiences that will leave you inspired.",
      para2: "Discover essential hiking techniques, safety measures, and packing tips to prepare for your adventure. Whether you’re a novice hiker or an outdoor enthusiast, these trails provide the perfect balance of challenge and beauty.",
      para3: "Immerse yourself in the captivating beauty of these adventure-filled trails. Traverse through lush forests, serene valleys, and rugged mountain paths that promise both excitement and tranquility.",
      para4: "Be inspired by our curated gallery showcasing the magnificence of these unforgettable hiking trails. Let the breathtaking imagery fuel your passion for exploration and motivate you to take your next adventure step."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Hiking", "Adventure", "Roadtrip"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Olivia Williams",
        date: "21 May, 2025",
        content: "This guide is fantastic! I feel much more prepared for my first hiking trip now. Thank you for the tips!",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Alexander Smith",
            date: "22 May, 2025",
            content: "Totally agree! The trail recommendations are spot on for beginners and casual hikers."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Christopher Brown",
        date: "22 May, 2025",
        content: "Loving these adventure blogs. Can’t wait to try some of these trails this summer!"
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Family Travel",
    date: "29 July, 2025",
    admin: "Admin",
    heading: "Family Travel Tours Fun Escapades",
    important: {
      content: "Planning a family vacation has never been easier. Discover fun-filled tour ideas that cater to all ages, ensuring unforgettable memories with your loved ones.",
      intro: "Family Travel Expert"
    },
    paragraph: {
      para1: "Embark on exciting family-friendly tours that blend adventure, relaxation, and educational experiences. From amusement parks to nature retreats, these escapades are designed to create lasting memories for every family member.",
      para2: "Learn how to plan seamless family trips, including choosing destinations, kid-friendly accommodations, and essential travel tips to keep everyone happy and entertained throughout the journey.",
      para3: "Discover tours that offer a perfect balance between fun activities and meaningful cultural experiences. Explore local attractions, enjoy group adventures, and engage in bonding moments with your family.",
      para4: "Get inspired by our gallery featuring joyful moments from family tours. Let these images spark your imagination for your next family getaway filled with laughter, learning, and adventure."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["Family", "Adventure", "Roadtrip"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Sophia Johnson",
        date: "09 May, 2025",
        content: "This article is a lifesaver! Planning family trips always felt overwhelming, but these ideas make it so much easier.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Ethan Miller",
            date: "10 May, 2025",
            content: "Absolutely! The destination tips are very practical, especially for families with young kids."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Isabella Garcia",
        date: "10 May, 2025",
        content: "Can’t wait to try one of these family tours this summer. Thanks for the awesome suggestions!"
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Destination Guides",
    date: "22 July, 2025",
    admin: "Admin",
    heading: "Discover Turkey Hidden Gem Locations",
    important: {
      content: "Unveil Turkey’s lesser-known destinations that boast breathtaking landscapes, rich history, and authentic cultural experiences away from the usual tourist crowds.",
      intro: "Travel Enthusiast"
    },
    paragraph: {
      para1: "Turkey is a treasure trove of hidden gems waiting to be explored. Beyond the iconic landmarks, you’ll find charming villages, secluded beaches, and ancient ruins that offer an intimate glimpse into the country's diverse heritage.",
      para2: "This guide takes you off the beaten path, introducing you to secret spots like the fairy chimneys of Cappadocia, the untouched coves of the Aegean coast, and mystical underground cities.",
      para3: "Whether you're seeking a peaceful retreat in nature or a deep dive into Turkey's historical marvels, these hidden gems provide unique experiences that go beyond the typical tourist trail.",
      para4: "Explore our visual gallery showcasing these offbeat destinations. Let the stunning imagery inspire your next Turkish adventure filled with discovery and cultural immersion."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["Turkey", "Adventure", "Hiking"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Liam Anderson",
        date: "16 April, 2025",
        content: "I’ve been to Turkey twice but never knew about these places! Definitely adding them to my next itinerary.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Emma Wilson",
            date: "16 April, 2025",
            content: "Same here! Love discovering hidden spots that aren't crowded with tourists."
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Noah Thomas",
        date: "17 April, 2025",
        content: "Amazing guide! This is exactly the kind of travel inspiration I was looking for."
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Travel Tips",
    date: "15 July, 2025",
    admin: "Admin",
    heading: "Packing and Beauty Tips Essentials Guide",
    important: {
      content: "Master the art of smart packing and keep your beauty routine intact while traveling. Discover essential tips to stay organized, stylish, and refreshed on every trip.",
      intro: "Travel Style Expert"
    },
    paragraph: {
      para1: "Traveling doesn’t mean compromising on style or comfort. This guide offers practical packing strategies and beauty hacks to ensure you travel light while having everything you need.",
      para2: "From choosing versatile outfits to packing multi-purpose beauty products, learn how to optimize your luggage space without leaving your essentials behind. Our tips are designed for hassle-free and chic travels.",
      para3: "Stay fresh and confident on the go with quick skincare routines, in-flight beauty tips, and must-have travel-size products. Whether it's a weekend getaway or a long vacation, preparation is key to a stress-free trip.",
      para4: "Dive into our gallery of packing layouts and travel beauty kits to visualize the perfect travel checklist. These visuals will inspire you to pack smarter and travel in style."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Packing", "Beauty", "Adventure"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Amelia Davis",
        date: "26 April, 2025",
        content: "This guide is so helpful! Packing has always been a struggle for me, but these tips make it so much easier.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Mason Harris",
            date: "26 April, 2025",
            content: "Loved the minimalist packing advice! Definitely using these hacks for my next trip."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Charlotte Moore",
        date: "27 April, 2025",
        content: "Great beauty product recommendations! I always overpack, so this will really help streamline my routine."
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Food and Dining",
    date: "9 July, 2025",
    admin: "Admin",
    heading: "Exploring Street Food Culinary Delights Tour",
    important: {
      content: "Embark on a flavorful journey through bustling streets and hidden alleys, discovering mouth-watering street food that defines local culinary traditions.",
      intro: "Culinary Explorer"
    },
    paragraph: {
      para1: "Street food is the heart and soul of many cultures. This tour guide introduces you to iconic street eats, from sizzling grills to aromatic spice stalls, offering authentic flavors at every corner.",
      para2: "Learn how to navigate food markets, find hygienic and popular stalls, and savor must-try delicacies that locals swear by. Discover how street food brings communities together through shared tastes and traditions.",
      para3: "Experience the joy of trying new dishes while learning about their cultural significance. From sweet desserts to savory snacks, every bite tells a story of the region’s rich culinary heritage.",
      para4: "Our gallery showcases the vibrant colors and irresistible charm of street food scenes around the world. Let these visuals inspire your next food adventure as you explore flavors beyond restaurant menus."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["Streetfood", "Adventure", "Turkey"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "James Walker",
        date: "06 April, 2025",
        content: "This guide has me craving street food already! Can't wait to explore the local food markets on my next trip.",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Emily Scott",
            date: "06 April, 2025",
            content: "Street food is the best way to experience a city’s true flavors. Great recommendations here!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Daniel Young",
        date: "07 April, 2025",
        content: "Loved the tips on finding clean and authentic food stalls. Super useful for first-time travelers!"
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "destination guides",
    date: "3 July, 2025",
    admin: "Admin",
    heading: "Road Trips Scenic Journey Routes",
    important: {
      content: "Hit the open road and embark on breathtaking road trips that take you through scenic landscapes, charming towns, and unforgettable adventures along the way.",
      intro: "Road Trip Enthusiast"
    },
    paragraph: {
      para1: "Discover the joy of road trips with carefully curated routes that offer stunning vistas, hidden attractions, and memorable pit stops. Whether it's coastal drives or mountainous passes, these journeys are perfect for travelers seeking freedom and exploration.",
      para2: "Learn how to plan the ultimate road trip, from choosing the best routes to packing essentials and ensuring vehicle readiness. Our guide ensures your trip is smooth, enjoyable, and filled with spontaneous discoveries.",
      para3: "Experience the thrill of unplanned detours, scenic photo stops, and local encounters that make road trips truly unique. Every mile driven adds a new story to your adventure.",
      para4: "Browse through our gallery of picturesque road trip moments to fuel your wanderlust. Let these images inspire your next journey, where the road itself becomes the destination."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Roadtrip", "Adventure", "Hiking"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Michael Robinson",
        date: "28 March, 2025",
        content: "This post has me itching for a road trip! Great route suggestions and travel tips.",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Sophia Martinez",
            date: "28 March, 2025",
            content: "Road trips are my favorite way to explore! Thanks for the packing checklist ideas."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Benjamin Clark",
        date: "29 March, 2025",
        content: "Fantastic article! Planning a weekend drive next month and this guide is perfect."
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Trail Adventures",
    date: "27 June, 2025",
    admin: "Admin",
    heading: "Memorable Hiking Trail Adventure Journeys",
    important: {
      content: "Embark on memorable hiking adventures that take you through awe-inspiring landscapes, challenging terrains, and soul-refreshing nature trails.",
      intro: "Outdoor Adventure Guide"
    },
    paragraph: {
      para1: "Hiking is more than just a walk—it’s an adventure that connects you to nature and tests your limits. Discover some of the most memorable hiking trails that offer a perfect blend of thrill, beauty, and serenity.",
      para2: "Prepare for these journeys with expert tips on route selection, fitness preparation, and essential gear. Whether you’re an avid trekker or a nature enthusiast, these trails promise experiences that stay with you for a lifetime.",
      para3: "Traverse through lush forests, climb rugged mountain paths, and find peace in hidden valleys. Every trail brings a unique adventure, from sunrise summits to quiet sunset descents.",
      para4: "Explore our gallery capturing the spirit of these unforgettable hikes. Let the visuals inspire you to step into your next journey, where every step leads to a new discovery."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Hiking", "Adventure", "Roadtrip"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Ella Thompson",
        date: "06 May, 2025",
        content: "These trails look amazing! Adding a few to my hiking bucket list for this year.",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Lucas White",
            date: "06 May, 2025",
            content: "Same here! Love how detailed the preparation tips are."
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Mia Hall",
        date: "07 May, 2025",
        content: "Great read! The photo gallery really brings the hiking vibes to life."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Family Travel",
    date: "21 June, 2025",
    admin: "Admin",
    heading: "Exciting Family Travel Tour Adventures",
    important: {
      content: "Turn your family vacations into thrilling adventures with tours designed to delight every age. Discover destinations packed with fun activities, cultural experiences, and bonding moments.",
      intro: "Family Adventure Planner"
    },
    paragraph: {
      para1: "Family trips don’t have to be just about sightseeing—they can be action-packed journeys filled with exciting activities that keep both kids and adults entertained. This guide highlights the best family-friendly tours that balance fun, relaxation, and learning.",
      para2: "Plan a stress-free adventure with tips on choosing kid-friendly destinations, organizing group activities, and ensuring everyone has a fantastic time. From amusement parks to wildlife safaris, there’s something for every family.",
      para3: "Explore tours that offer interactive experiences, like farm visits, cultural workshops, and nature excursions that foster curiosity and connection among family members.",
      para4: "Dive into our gallery of joyful family moments captured during these adventures. Let these images inspire your next vacation where laughter, discovery, and shared memories are at the heart of every day."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["Family", "Adventure", "Hiking"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Harper Lewis",
        date: "13 May, 2025",
        content: "Loved this blog! It’s so hard to find tours that keep both kids and adults engaged, but these ideas are perfect.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Jackson Evans",
            date: "13 May, 2025",
            content: "Agreed! The balance of fun and learning makes these tours stand out."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Avery Mitchell",
        date: "14 May, 2025",
        content: "Can’t wait to plan our next family trip using these suggestions. Thanks for the inspiration!"
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Destination Guides",
    date: "14 June, 2025",
    admin: "Admin",
    heading: "Explore Turkey's Secret Hidden Gems",
    important: {
      content: "Step away from the usual tourist spots and uncover Turkey's secret destinations—breathtaking places rich in history, culture, and natural beauty waiting to be explored.",
      intro: "Hidden Destinations Expert"
    },
    paragraph: {
      para1: "Turkey is home to countless hidden treasures, from quaint villages and serene coastal towns to ancient ruins and breathtaking natural wonders. This guide uncovers secret locations that offer a more authentic and immersive travel experience.",
      para2: "Discover lesser-known sites like the ancient city of Aizanoi, the tranquil lakes of Egirdir, and the untouched beauty of Bozcaada Island. These spots are perfect for travelers seeking peace, culture, and scenic beauty away from the crowds.",
      para3: "Learn how to navigate these destinations, interact with local communities, and savor the rich traditions and flavors of Turkish culture. Experience a side of Turkey that’s rarely seen in travel brochures.",
      para4: "Explore our gallery showcasing these hidden gems in their raw beauty. Let the imagery inspire your next journey to discover Turkey’s most enchanting and off-the-beaten-path locations."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["Turkey", "Adventure", "Hiking"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Henry Parker",
        date: "19 May, 2025",
        content: "I had no idea about these places! This is exactly the kind of unique travel experience I’ve been looking for.",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Lily Cooper",
            date: "19 May, 2025",
            content: "Same here! Love discovering destinations that aren’t overrun with tourists."
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Sebastian Turner",
        date: "20 May, 2025",
        content: "Fantastic recommendations. I’m definitely planning a trip to these hidden gems next year!"
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Travel Tips",
    date: "5 June, 2025",
    admin: "Admin",
    heading: "Essential Packing and Beauty Travel Guide",
    important: {
      content: "Stay stylish and organized on your journeys with expert packing strategies and beauty essentials that keep you looking fresh and travel-ready.",
      intro: "Travel Style Coach"
    },
    paragraph: {
      para1: "Packing smart is the key to stress-free travel. This guide shares essential tips on organizing your luggage efficiently while ensuring you have all the beauty must-haves for a flawless look on the go.",
      para2: "Learn how to build a capsule wardrobe for travel, select multi-use beauty products, and pack efficiently without overloading your bags. We also share space-saving hacks for fitting everything you need without compromising style.",
      para3: "Discover quick beauty routines tailored for travelers, in-flight skincare tips, and product recommendations that are TSA-friendly. Stay fresh and photo-ready no matter where your journey takes you.",
      para4: "Explore our gallery of travel kits, packing lists, and beauty travel sets to visualize the perfect setup. Let these visuals inspire you to pack light, stay organized, and travel confidently."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Packing", "Beauty", "Family"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Grace Bennett",
        date: "23 May, 2025",
        content: "Loved these packing hacks! I always overpack, but this guide has given me a clear strategy.",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Logan Brooks",
            date: "23 May, 2025",
            content: "Same! The capsule wardrobe tip is a game-changer for frequent travelers."
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Chloe Adams",
        date: "24 May, 2025",
        content: "This is exactly what I needed for my upcoming trip. Thanks for the beauty essentials checklist!"
      }
    ]
  }

];

export default blogs;